const BlogData = [
    {
        id: 1,
        title: "Astronomers discover Planet",
        description: `A supernova is the explosion that occurs in the final throes of a dying,
                     powerful star – with some of the largest thought to cause black holes to 
                     form.`,
        img: require("../images/news (1).jpg"),
        published: "4 March 2020",
        publishedBy: "By Admin"
    },
    {
        id: 2,
        title: "Astronomers discover Planet",
        description: `A supernova is the explosion that occurs in the final throes of a dying,
                     powerful star – with some of the largest thought to cause black holes to 
                     form.`,
        img: require("../images/news (2).jpg"),
        published: "4 March 2020",
        publishedBy: "By Admin"
    },
    {
        id: 3,
        title: "Astronomers discover Planet",
        description: `A supernova is the explosion that occurs in the final throes of a dying,
                     powerful star – with some of the largest thought to cause black holes to 
                     form.`,
        img: require("../images/news (3).jpg"),
        published: "4 March 2020",
        publishedBy: "By Admin"
    },
    {
        id: 4,
        title: "Astronomers discover Planet",
        description: `A supernova is the explosion that occurs in the final throes of a dying,
                     powerful star – with some of the largest thought to cause black holes to 
                     form.`,
        img: require("../images/news (4).jpg"),
        published: "4 March 2020",
        publishedBy: "By Admin"
    }
  
]

export default BlogData;